import React from 'react';
import translate from '../translate';
import { useSelector } from 'react-redux';

function About() {
    const language = useSelector(state=>state.view.selectedLanguage); // Set the desired language
    const componentName = 'about'; // Set the component name

    return (
        <div className="about-section about-section__style-2 pt-125 pb-130">
        <div className="container">
            <div className="row">
                <div className="col-xl-6">
                    <div className="section-heading section-heading__style-2">
                        <span className="sub-heading">{translate(componentName, 'title', language)}</span><br/>
                        <h2 className="heading">{translate(componentName, 'subtitle', language)}</h2>
                    </div>
                </div>
                <div className="col-xl-6">
                    <div className="about-content">
                        <div className="section-heading">
                            <h5 className="section-meta">{translate(componentName, 'whoWeAre', language)}</h5>
                            <br/>
                            <h2 className="section-title">{translate(componentName, 'companyName', language)}</h2>
                            <br/>
                            <p className="section-text">{translate(componentName, 'description1', language)}</p>
                            <p className="section-text">{translate(componentName, 'description2', language)}</p>
                            <p className="section-text">{translate(componentName, 'description3', language)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-12">
                    <div className="about-img mt-75">
                        <div className="thumb">
                            <img src="assets/img/about/about.jpeg" alt={translate(componentName, 'videoAlt', language)}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default About;